import React, { useState } from "react";
import { Box, Container, Grid } from "@mui/material";

import {
  delay,
  findGetParameter,
  getData,
} from "../../../components/utilities/UtilityFunctions";
import { useEffect } from "react";
import ModalLoadingFull from "../../../components/modals/ModalLoadingFull";

import mappingData from "./demoData/mappingData.json";

import GroupHeader from "./components/GroupHeader";
import GroupMedalBox from "./components/GroupMedalBox";
import { postNotification } from "../../../components/utilities/Notifications";

export default function GroupMedals({
  eventGroupId,
  groupName,
  groupNamePlural,
  label,
  appRoute,
}) {
  const [loading, setLoading] = useState(true);
  const [groupData, setGroupData] = useState(null);

  const embed = appRoute || findGetParameter("embed") === "true";

  const updateData = async () => {
    try {
      var apiData = await getData(`/players/gwworlds`, {
        queryStringParameters: {
          groupQuery: true,
          eventGroupId: eventGroupId || "WorldChamps23",
          limit: 500,
        },
      });
      if (apiData?.data?.length) {
        const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

        for (let i = 0; i < apiData.data.length; i++) {
          apiData.data[i].name =
            apiData.data[i].label ||
            `${apiData.data[i].firstName} ${apiData.data[i].lastName}`.trim();
          if (!apiData.data[i].countryCode) {
            apiData.data[i].countryCode =
              mappingData[apiData.data[i].label || apiData.data[i].groupName] ||
              apiData.data[i].label ||
              apiData.data[i].groupName;
          }
          if (apiData.data[i]?.countryCode) {
            try {
              let tempName = regionNames.of(apiData.data[i]?.countryCode);
              if (tempName) {
                apiData.data[i].groupName = tempName;
                apiData.data[i].name = tempName;
                apiData.data[i].label = tempName;
              }
            } catch (err) {
              //
            }
          }
        }

        let _groupData = apiData?.data;
        if (_groupData?.length) {
          _groupData.sort((a, b) => {
            let aMedal = a.wcwGold || 0;
            let bMedal = b.wcwGold || 0;
            if (aMedal !== bMedal) return bMedal - aMedal;

            aMedal = a.wcwSilver || 0;
            bMedal = b.wcwSilver || 0;
            if (aMedal !== bMedal) return bMedal - aMedal;

            aMedal = a.wcwBronze || 0;
            bMedal = b.wcwBronze || 0;
            if (aMedal !== bMedal) return bMedal - aMedal;

            return 0;
          });

          let r = 1;
          _groupData[0].place = 1;
          for (let i = 1; i < _groupData.length; i++) {
            if (
              _groupData[i].wcwGold !== _groupData[i - 1].wcwGold ||
              _groupData[i].wcwSilver !== _groupData[i - 1].wcwSilver ||
              _groupData[i].wcwBronze !== _groupData[i - 1].wcwBronze
            ) {
              r = i + 1;
            }
            _groupData[i].place = r;
          }
        }

        setGroupData(_groupData);
      }
    } catch (err) {
      postNotification("error", err);
    }
    setLoading(false);

    await delay(60 * 2.5 * 1000);

    updateData();
  };

  useEffect(() => {
    updateData();
    // eslint-disable-next-line
  }, []);

  if (loading) {
    return <ModalLoadingFull />;
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ maxWidth: "100%" }}>
        <Container maxWidth="lg">
          <GroupHeader label={label} embed={embed} />
        </Container>
      </Box>
      <Container
        maxWidth="lg"
        sx={{ pt: 2, pb: 2, backgroundColor: "background.secondary" }}
      >
        <Grid container spacing={1} sx={{ p: [1, 1, 2] }}>
          <Grid item xs={12}>
            <GroupMedalBox
              groupNamePlural="countries"
              label="Medal Count"
              activeTab={0}
              groupName={"Country"}
              groupData={groupData}
              showMedals
              hideCompleteLeaders
              eventGroupId={eventGroupId}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
